import * as React from 'react';
import Hero from './Hero';
import FAQ from './Faq';
import AppPromotion from './AppPromotion';
import Producs from './Products';
import Brands from './Brands';
import Video from './Video';
import News from './News';

export default function Home() {
    return(
        <React.Fragment>
        <Hero></Hero>
        {/*<Brands></Brands>*/}
        <AppPromotion></AppPromotion>
        <News></News>
        <Producs></Producs>
       {/* <Video></Video>*/}
        <FAQ></FAQ>
        </React.Fragment>
    )

}